// extracted by mini-css-extract-plugin
module.exports = {"informationDetail":"PaymentMethodDetail_informationDetail__Uepld","informationDetail_content":"PaymentMethodDetail_informationDetail_content__1ez9z"};